<template>
  <ion-page>
    <!-- Fixed Header -->
    <ion-header class="header-container">
      <ion-toolbar class="header-toolbar">
        <ion-buttons slot="start">
          <ion-back-button
            default-href="/cart"
            color="light"
            text=""
          ></ion-back-button>
        </ion-buttons>
        <ion-title class="page-title">Checkout</ion-title>
      </ion-toolbar>
    </ion-header>

    <!-- Scrollable Content -->
    <ion-content>
      <ion-row class="heading-row-list">
        <h1 class="heading-category">Order Summary</h1>
      </ion-row>
      <div class="orderlist-div" v-for="orders in cartOrders" :key="orders.id">
        <ion-row class="row-orderlist">
          <ion-col size="1">
            <span class="product-cart-quantity">{{ orders.quantity }} x</span>
          </ion-col>
          <ion-col size="8">
            <span class="product-cart-name">
              {{ orders.product.productName }}
            </span>
            <div v-for="(variations, key) in orders.variations" :key="key">
              <span class="product-cart-addon" v-if="variations !== null">
                <span v-if="variations.category" class="variation-category">
                  {{ variations.category }}:
                </span>
                <span class="variation-value">{{ variations.name }}</span>
                <span
                  v-if="
                    (variations.name.includes('Sugar') ||
                      variations.name.includes('Sweetener')) &&
                    !variations.name.includes('No Sugar') &&
                    variations.quantity > 0
                  "
                >
                  x {{ variations.quantity }}
                </span>
              </span>
            </div>
            <div v-if="orders.instructions !== ''">
              <span class="product-cart-name">
                Special Instructions: <br />
              </span>
              <span class="product-cart-addon">{{ orders.instructions }}</span>
            </div>
          </ion-col>
          <ion-col size="2">
            <span class="product-cart-price">
              $ {{ parseFloat(orders.pricePerOrder).toFixed(2) }}
            </span>
          </ion-col>
          <ion-col size="1">
            <a @click="removeCartOrder(orders.uuid)">
              <img
                src="assets/icon/trash.png"
                class="trash-icon"
                color="primary"
              />
            </a>
          </ion-col>
        </ion-row>
      </div>

      <ion-row class="heading-row-list"
        ><h1 class="heading-category">Pickup</h1></ion-row
      >
      <ion-row class="checkout-row">
        <ion-col>
          <OrderTime name="OrderTime" />
        </ion-col>
      </ion-row>

      <ion-row class="payment-row">
        <ion-col size="6" class="payment-col">
          <ion-icon src="assets/icon/card.svg" class="banner-icon"></ion-icon>
          <span class="payment-label">Payment Method</span>
        </ion-col>
        <ion-col size="6" class="payment-icons-col">
          <img
            src="assets/icon/visa.png"
            class="payment-method-icon"
            alt="Visa"
          />
          <img
            src="assets/icon/mastercard.png"
            class="payment-method-icon"
            alt="Mastercard"
          />
          <img
            v-if="isApplePayAvailable"
            src="assets/icon/apple-pay-official.svg"
            class="payment-method-icon"
            alt="Apple Pay"
          />
        </ion-col>
      </ion-row>
      <RewardsComponent
        name="RewardsComponent"
        @rewards-type="rewardsType($event)"
      />
      <!-- Add bottom padding to prevent content from being hidden under fixed footer -->
      <div style="height: 240px"></div>
    </ion-content>

    <!-- Fixed Footer with Totals and Button -->
    <div class="checkout-footer">
      <ion-row class="row-sub">
        <ion-col>
          <span class="product-sublabel">
            SubTotal ({{ totalCartQty }} item/s)
          </span>
        </ion-col>
        <ion-col>
          <span class="product-subtotal">
            $ {{ subTotalCartPrice.toFixed(2) }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row class="row-sub" v-if="discountPrice > 0">
        <ion-col><span class="product-sublabel">Discount</span> </ion-col>
        <ion-col>
          <span class="product-subtotal">
            - $ {{ discountPrice.toFixed(2) }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row class="row-sub">
        <ion-col><span class="product-sublabel">Service Fee</span> </ion-col>
        <ion-col>
          <span class="product-subtotal"> $ {{ serviceFee.toFixed(2) }} </span>
        </ion-col>
      </ion-row>
      <ion-row class="row-total">
        <ion-col><span class="product-total-label">Total</span> </ion-col>
        <ion-col>
          <span class="product-cart-price2">
            $ {{ totalCartPrice.toFixed(2) }}
          </span>
        </ion-col>
      </ion-row>
      <!-- Web Stripe Checkout -->
      <div v-if="isMobileWeb || isDesktop">
        <ion-button
          expand="block"
          color="primary"
          class="carttext-btn"
          @click="placeStripeWebOrder"
          :disabled="!isCafeOpen || isProcessing"
        >
          {{
            isProcessing
              ? "Processing..."
              : isCafeOpen
              ? "Place Order"
              : "Cafe Closed"
          }}
        </ion-button>
      </div>
      <!-- Native Mobile Stripe Checkout -->
      <div v-else-if="isAndroid || isIOS">
        <ion-button
          expand="block"
          color="primary"
          class="carttext-btn"
          @click="placeStripeCapacitorOrder"
          :disabled="!isCafeOpen || isProcessing"
        >
          {{
            isProcessing
              ? "Processing..."
              : isCafeOpen
              ? "Place Order"
              : "Cafe Closed"
          }}
        </ion-button>
      </div>
    </div>
  </ion-page>
</template>
<script>
import { defineComponent } from "vue";
import axios from "axios";
import OrderTime from "@/components/OrderTime.vue";
import RewardsComponent from "@/views/order/RewardsComponent.vue";

import {
  IonRow,
  IonCol,
  IonModal,
  IonButton,
  IonItem,
  IonSelect,
  IonSelectOption,
  IonDatetime,
  IonDatetimeButton,
  IonPage,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonList,
  IonIcon,
  alertController,
  toastController,
  isPlatform,
  getPlatforms,
} from "@ionic/vue";
import { loadStripe } from "@stripe/stripe-js";
import { Capacitor } from "@capacitor/core";
import { Stripe } from "@capacitor-community/stripe";

const BASE_URI =
  process.env.VUE_APP_BASE_URI !== undefined
    ? process.env.VUE_APP_BASE_URI
    : "https://api.onecoffeeapp.com.au";

const PUBLISHABLE_KEY = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY || PUBLISHABLE_KEY === "") {
  console.error(
    "FATAL: VUE_APP_STRIPE_PUBLISHABLE_KEY is not configured. Payment functionality will not work."
  );
}

if (Capacitor.isPluginAvailable("Stripe")) {
  if (PUBLISHABLE_KEY) {
    Stripe.initialize({
      publishableKey: PUBLISHABLE_KEY,
    });
  } else {
    console.error("Cannot initialize Stripe: missing publishable key");
  }
}

export default defineComponent({
  name: "CheckoutPage",
  components: {
    OrderTime,
    IonRow,
    IonCol,
    IonModal,
    IonButton,
    IonItem,
    IonSelect,
    IonSelectOption,
    IonDatetime,
    IonDatetimeButton,
    IonPage,
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonBackButton,
    IonList,
    IonIcon,
    RewardsComponent,
  },
  data() {
    return {
      cartOrders: [],
      cartOrderIds: [],
      totalCartQty: 0,
      subTotalCartPrice: 0,
      serviceFee: 0,
      currentCartPrice: 0,
      totalCartPrice: 0,
      promptMessage: "",
      cartStatus: "",
      tempRewards: [],
      rewardsList: [],
      lowestCartPrice: 0,
      discountPrice: 0,
      rewardsId: "",
      devicePlatform: [],
      isDesktop: false,
      isMobileWeb: false,
      isAndroid: false,
      isIOS: false,
      isApplePayAvailable: false,
      isProcessing: false,
    };
  },
  computed: {
    isCafeOpen() {
      // Use the isOpen status from the API response
      if (
        !this.cartOrders ||
        this.cartOrders.length === 0 ||
        !this.cartOrders[0].cafe
      ) {
        return false;
      }
      // Default to false if isOpen is not set
      return this.cartOrders[0].cafe.isOpen === true;
    },
  },
  methods: {
    checkApplePayAvailability() {
      // Use Capacitor to reliably detect native vs web platform
      const platform = Capacitor.getPlatform(); // Returns "ios", "android", or "web"

      // Only show Apple Pay on iOS native app
      if (platform === "ios") {
        this.isApplePayAvailable = true;
        return;
      }

      // For web platform: Check if it's mobile iOS Safari with Apple Pay support
      if (platform === "web") {
        // Check if running on iOS mobile device (not desktop Safari)
        const isIOSMobile = /iPhone|iPad|iPod/.test(navigator.userAgent);

        if (isIOSMobile && window.ApplePaySession) {
          try {
            // Check if the device supports Apple Pay
            if (window.ApplePaySession.canMakePayments()) {
              this.isApplePayAvailable = true;
              return;
            }
          } catch (error) {
            console.log("Apple Pay check failed:", error);
          }
        }
      }

      // Default: Don't show Apple Pay
      this.isApplePayAvailable = false;
    },
    async rewardsType(value) {
      this.rewardsId = value ? value.uuid : "";

      this.serviceFee = this.totalCartQty * 0.5;
      this.totalCartPrice = this.currentCartPrice;

      if (value !== null && value.type.toLowerCase() == "free_regular") {
        if (this.cartOrderIds.length == 1) {
          this.discountPrice = this.lowestCartPrice / this.totalCartQty;
          this.serviceFee = this.serviceFee - 0.5;
          this.totalCartPrice =
            this.totalCartPrice - (this.discountPrice + 0.5);
        } else {
          this.discountPrice = this.lowestCartPrice;
          this.serviceFee = this.serviceFee - 0.5;
          this.totalCartPrice =
            this.totalCartPrice - (this.discountPrice + 0.5);
        }
      } else if (value !== null && value.type.toLowerCase() == "off_price_2") {
        this.discountPrice = 2;
        this.totalCartPrice = this.totalCartPrice - this.discountPrice;
      } else if (
        value !== null &&
        value.type.toLowerCase() == "off_percent_20"
      ) {
        this.discountPrice = this.subTotalCartPrice * 0.2;
        this.totalCartPrice = this.totalCartPrice - this.discountPrice;
      } else {
        this.discountPrice = 0;
        this.totalCartPrice = this.currentCartPrice;
      }
    },
    async presentAlert(id) {
      if (id) {
        const alert = await alertController.create({
          subHeader: "Are you sure you want to delete this item?",
          buttons: [
            {
              text: "No",
              role: "cancel",
              handler: () => {},
            },
            {
              text: "Yes",
              role: "confirm",
              handler: () => {
                this.removeCartOrder(id);
              },
            },
          ],
        });

        await alert.present();
        await alert.onDidDismiss();
      } else {
        const alert = await alertController.create({
          message: this.promptMessage,
        });

        await alert.present();
        await alert.onDidDismiss();

        if (this.totalCartQty == 1) window.location.href = "/cart";
        else if (this.cartStatus == 400) window.location.href = "/cart";
        else window.location.reload();
      }
    },
    async getCartOrders(userId, cafeId) {
      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let url = userId
        ? BASE_URI +
          "/cart/get-cart-orders/?userId=" +
          userId +
          "&status=pending" +
          "&cafeId=" +
          cafeId
        : BASE_URI + "/cafe/get-coffee-shops";

      let result = await axios
        .get(url, axiosConfig)
        .then((res) => res.data)
        .catch((err) => {
          this.promptMessage = "No cart order/s available.";
          this.cartStatus = err.response.status;
          this.presentAlert();
          throw err.response.status;
        });

      this.cartOrders = result && result.data.length ? await result.data : [];
      const cartOrderPrices = [];

      for (let i = 0; i < this.cartOrders.length; i++) {
        this.cartOrderIds.push(this.cartOrders[i].id);
        this.totalCartQty += this.cartOrders[i].quantity;
        this.subTotalCartPrice += parseFloat(this.cartOrders[i].pricePerOrder);

        cartOrderPrices.push(parseFloat(this.cartOrders[i].pricePerOrder));
      }

      this.lowestCartPrice = cartOrderPrices.length
        ? Math.min(...cartOrderPrices)
        : 0;
      this.serviceFee = this.totalCartQty * 0.5;
      this.currentCartPrice = this.subTotalCartPrice + this.serviceFee;
      this.totalCartPrice = this.subTotalCartPrice + this.serviceFee;
    },
    async removeCartOrder(cartOrderId) {
      let headers = {
        Authorization: localStorage.getItem("token"),
        "Content-Type": "application/json;charset=UTF-8",
      };

      let paramsData = {
        id: cartOrderId,
      };

      try {
        await axios.delete(BASE_URI + "/cart/delete-cart-order", {
          headers,
          data: paramsData,
        });

        // Find and remove the item from cartOrders
        const removedOrder = this.cartOrders.find(
          (order) => order.uuid === cartOrderId
        );
        this.cartOrders = this.cartOrders.filter(
          (order) => order.uuid !== cartOrderId
        );

        // Recalculate totals
        if (removedOrder) {
          this.totalCartQty -= removedOrder.quantity;
          this.subTotalCartPrice -= parseFloat(removedOrder.pricePerOrder);
          this.serviceFee = this.totalCartQty * 0.5;
          this.currentCartPrice = this.subTotalCartPrice + this.serviceFee;
          this.totalCartPrice =
            this.currentCartPrice - (this.discountPrice || 0);

          // Update cartOrderIds
          this.cartOrderIds = this.cartOrderIds.filter(
            (id) => id !== removedOrder.id
          );

          // Recalculate lowest cart price for rewards
          const cartOrderPrices = this.cartOrders.map((order) =>
            parseFloat(order.pricePerOrder)
          );
          this.lowestCartPrice = cartOrderPrices.length
            ? Math.min(...cartOrderPrices)
            : 0;
        }

        // Show toast notification
        const toast = await toastController.create({
          message: "Item has been removed from the cart.",
          duration: 2000,
          position: "top",
          cssClass: "custom-toast",
        });
        await toast.present();

        // Update Vuex store
        await this.$store.dispatch("fetchCartOrders", { force: true });

        // Redirect to cart if no items left
        if (this.cartOrders.length === 0) {
          window.location.href = "/cart";
        }
      } catch (err) {
        const toast = await toastController.create({
          message: "Failed to remove item. Please try again.",
          duration: 2000,
          position: "top",
          cssClass: "custom-toast toast-danger",
        });
        await toast.present();
        throw err.response?.status || err;
      }
    },
    async placeStripeWebOrder() {
      this.isProcessing = true;

      try {
        let stripe = await loadStripe(PUBLISHABLE_KEY);

        // Minimal checkout payload - backend creates draft order with all details
        let paramsCheckoutData = JSON.stringify({
          cafeId: this.cartOrders[0].cafe.cafeId,
          rewardsId: this.rewardsId || null,
          routes: {
            success_url:
              window.location.origin +
              "/orderstatus?cafeId=" +
              this.cartOrders[0].cafe.cafeId,
            cancel_url: window.location.origin + "/cart",
          },
        });

        let axiosConfig = {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json;charset=UTF-8",
          },
        };

        await axios
          .post(
            BASE_URI + "/payments/checkout",
            paramsCheckoutData,
            axiosConfig
          )
          .then(async (response) => {
            // Backend now returns order_uuid - draft order already created
            const { id: sessionId, order_uuid } = response.data.data;

            // Validate sessionId before proceeding
            if (!sessionId || sessionId.trim() === "") {
              const errorMsg = "Missing Stripe sessionId from backend";
              console.error(errorMsg, response.data);
              this.promptMessage =
                "Unable to create payment session. Please try again.";
              await this.presentAlert();
              throw new Error(errorMsg);
            }

            // Optional: Store order_uuid in sessionStorage for reference
            if (order_uuid) {
              sessionStorage.setItem("last_order_uuid", order_uuid);
            }

            // Success URL will include order_uuid parameter (set by backend)
            return { sessionId };
          })
          .then(({ sessionId }) => {
            // Don't reset isProcessing here - user is being redirected
            return stripe.redirectToCheckout({ sessionId });
          });
      } catch (error) {
        this.isProcessing = false;
        throw error;
      }
    },
    async placeStripeCapacitorOrder() {
      this.isProcessing = true;

      try {
        console.log("Starting placeStripeCapacitorOrder...");

        // Check if we're actually in a native environment
        const isNative = Capacitor.isNativePlatform();
        console.log("Is native platform:", isNative);

        if (!isNative) {
          console.log(
            "Not on native platform, falling back to web checkout..."
          );
          // Fallback to web checkout if not on a native device (isProcessing already set)
          return await this.placeStripeWebOrder();
        }

        // Backend creates draft order and payment intent (single source of truth)
        console.log("Creating payment intent and draft order...");
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000);

        let data;
        try {
          const response = await fetch(BASE_URI + "/create-payment-intent", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("token"),
            },
            body: JSON.stringify({
              cafeId: this.cartOrders[0].cafe.cafeId,
              rewardsId: this.rewardsId || null,
              currency: "aud",
            }),
            signal: controller.signal,
          });

          clearTimeout(timeoutId);

          if (!response.ok) {
            throw new Error(
              `Payment intent creation failed: ${response.status}`
            );
          }

          data = await response.json();
        } catch (error) {
          clearTimeout(timeoutId);
          if (error.name === "AbortError") {
            throw new Error("Payment intent request timed out");
          }
          throw error;
        }

        console.log(
          "Payment intent created:",
          data.clientSecret ? "success" : "failed"
        );

        if (!data.clientSecret) {
          throw new Error("No clientSecret received from server");
        }

        const order_uuid = data.order_uuid;
        if (
          !order_uuid ||
          typeof order_uuid !== "string" ||
          order_uuid.trim() === ""
        ) {
          console.error("Invalid order_uuid received from server:", order_uuid);
          this.isProcessing = false;
          const alert = await alertController.create({
            header: "Error",
            message: "Failed to create order. Please try again.",
            buttons: ["OK"],
          });
          await alert.present();
          return;
        }
        console.log("Draft order created:", order_uuid);

        console.log("Creating payment sheet...");
        try {
          const createResult = await Stripe.createPaymentSheet({
            paymentIntentClientSecret: data.clientSecret,
            merchantDisplayName: this.cartOrders[0].cafe.shopName,
            enableApplePay: true,
            applePayMerchantId: "merchant.com.au.onecoffeeapp.app",
            withZipCode: false,
            countryCode: "AU",
          });
          console.log("Payment sheet created:", createResult);
        } catch (createError) {
          console.error("Error creating payment sheet:", createError);
          throw new Error(
            `Failed to create payment sheet: ${
              createError.message || createError
            }`
          );
        }

        console.log("Presenting payment sheet...");
        let paymentResult;
        try {
          const result = await Stripe.presentPaymentSheet();
          paymentResult = result.paymentResult;
          console.log("Payment result:", paymentResult);
        } catch (presentError) {
          console.error("Error presenting payment sheet:", presentError);
          throw new Error(
            `Failed to present payment sheet: ${
              presentError.message || presentError
            }`
          );
        }

        if (paymentResult === "paymentSheetCompleted") {
          console.log("Payment completed, navigating to order status...");

          // Validate order_uuid before navigation
          if (
            !order_uuid ||
            typeof order_uuid !== "string" ||
            order_uuid.trim() === ""
          ) {
            console.error("Cannot navigate: invalid order_uuid:", order_uuid);
            this.isProcessing = false;
            const alert = await alertController.create({
              header: "Error",
              message: "Order confirmation failed. Please contact support.",
              buttons: ["OK"],
            });
            await alert.present();
            return;
          }

          // Navigate with order_uuid - no localStorage needed
          // Don't reset isProcessing here - user is being redirected
          this.$router.push({
            path: "/orderstatus",
            query: {
              cafeId: this.cartOrders[0].cafe.cafeId,
              order_uuid: order_uuid, // Draft order already created
            },
          });
        } else {
          console.log("Payment was not completed:", paymentResult);
          this.isProcessing = false;
          const alert = await alertController.create({
            header: "Payment Cancelled",
            message: "Your payment was cancelled. Please try again.",
            buttons: ["OK"],
          });
          await alert.present();
        }
      } catch (error) {
        console.error("Payment error:", error);
        this.isProcessing = false;
        const alert = await alertController.create({
          header: "Payment Error",
          message:
            error.message ||
            "An error occurred while processing your payment. Please try again.",
          buttons: ["OK"],
        });
        await alert.present();
      }
    },
    async getRewardsByCafeId(cafeId) {
      let axiosConfig = {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json;charset=UTF-8",
        },
      };

      let url = BASE_URI + "/rewards/get-rewards-by-cafe-id?cafeId=" + cafeId;

      let result = await axios
        .get(url, axiosConfig)
        .then((res) => res.data)
        .catch((err) => {
          throw err.response.status;
        });

      this.tempRewards = result && result.data.length ? await result.data : [];

      for (let i = 0; i < this.tempRewards.length; i++) {
        let paramsData = {
          rewardsId: this.tempRewards[i].uuid,
          userId: localStorage.getItem("id"),
        };

        let axiosConfig = {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "application/json;charset=UTF-8",
          },
        };

        let url = BASE_URI + "/rewards/validate-redemption";

        let result = await axios
          .post(url, paramsData, axiosConfig)
          .then((res) => res.data)
          .catch((err) => {
            throw err.response.status;
          });

        let validate = result && result.data.length ? "redeemed" : "active";

        if (validate == "active") {
          this.rewardsList.push(this.tempRewards[i]);
        }
      }
    },
  },
  async created() {
    // check device platform
    this.devicePlatform = getPlatforms();
    this.isDesktop = isPlatform("desktop");
    this.isMobileWeb =
      this.devicePlatform.includes("android") ||
      this.devicePlatform.includes("ios")
        ? false
        : isPlatform("mobileweb");
    this.isAndroid = isPlatform("android");
    this.isIOS = isPlatform("ios");

    // Check if Apple Pay is available
    this.checkApplePayAvailability();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const cafeId = urlParams.get("cafeId") || "";
    const userId = localStorage.getItem("id") || null;

    if (cafeId == "") window.location.href = "/cart";
    else await this.getCartOrders(userId, cafeId);

    this.getRewardsByCafeId(cafeId);
  },
});
</script>
<style scoped>
.header-container {
  --background: #f87e63;
}

.header-toolbar {
  --background: #f87e63;
  --border-width: 0;
  --padding-top: 8px;
  --padding-bottom: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --min-height: 64px;
}

.page-title {
  --color: #ffffff;
  font-family: "Gilroy", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}

.checkout-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  box-shadow: 0px -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  padding-bottom: env(safe-area-inset-bottom);
}

.center {
  margin: auto;
}
.heading-row-list {
  background-color: #f9f9f9;
  padding-left: 5%;
  border-bottom: 1px solid #f3f3f3;
}
.heading-category {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  color: #1b1b1b;
  margin-top: 8%;
  margin-bottom: 15px;
}
.row-cart {
  padding: 10%;
}
.row-sub {
  padding-top: 0%;
  padding-left: 5%;
  padding-right: 0%;
}
.row-orderlist {
  padding-top: 0%;
  padding-left: 3%;
  padding-right: 0%;
}
.row-total {
  padding-top: 3%;
  padding-left: 2%;
  padding-right: 5%;
  margin-top: 3%;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
  margin-bottom: 40px;
}
.orderlist-div {
  padding-top: 10px;
  padding-bottom: 10px;
}
.product-cart-quantity {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
}
.product-cart-name {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
  padding: 0%;
}
.product-cart-addon {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #828282;
  display: block;
  padding: 0 10px;
  white-space: nowrap;
}
.variation-category {
  font-weight: 400;
  color: #828282;
  text-transform: capitalize;
}
.variation-value {
  font-weight: 600;
  color: #1b1b1b;
}
.product-total-label {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #828282;
  display: block;
  padding: 2%;
}
.product-cart-edit {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: #f87e63;
  display: block;
  padding: 2%;
}
.product-cart-price {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  text-align: right;
}
.product-cart-price2 {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #1b1b1b;
  position: absolute;
  right: -5px;
}
.product-subtotal {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  position: absolute;
  right: 16px;
}
.product-sublabel {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
}
ion-button {
  --background: #ffffff;
  --background-hover: #dce8ff;
  --background-activated: #dce8ff;
  --background-focused: #dce8ff;
  --color: #1b1b1b;
  --border-radius: 4px;
  --border-color: #f3f3f3;
  --border-style: solid;
  --border-width: 1px;
  --ripple-color: #dce8ff;
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 20px;
  margin-left: 15px;
  margin-right: 15px;
  height: 52px;
  text-transform: none;
  --box-shadow: none;
}
ion-button:active {
  --color: #f87e63;
}
.carttext-btn {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}
ion-select {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 120%;
  --placeholder-color: #ffc34d;
  --placeholder-opacity: 1;
}
ion-select::part(icon) {
  color: #ffffff;
  opacity: 0;
}
ion-select-option {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  color: #1b1b1b;
}
.select-fr {
  float: right;
}
.checkout-row {
  border-bottom: 1px solid #f3f3f3;
  padding-top: 5%;
  padding-bottom: 5%;
}
.payment-row {
  border-bottom: 1px solid #f3f3f3;
}
.payment-col {
  padding-top: 5%;
  padding-left: 5%;
}
.pickup-txt {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #1b1b1b;
}
.payment-option {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  color: #1b1b1b;
  display: block;
}
.banner-icon {
  vertical-align: middle;
  padding-right: 5px;
  width: 14px;
}
.payment-icons-col {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-top: 5%;
  padding-right: 5%;
  gap: 8px;
}
.payment-method-icon {
  height: 24px;
  width: auto;
  object-fit: contain;
}
.trash-icon {
  width: 16px;
}
.payment-label {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.02em;
  color: #1b1b1b;
  margin-left: 5px;
}
.payment-option {
  display: block;
}
.input-code {
  font-family: "Gilroy";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #828282;
  border-bottom: #ebebeb 1px solid;
  text-align: right;
  text-transform: uppercase;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  appearance: none;
  outline: 0;
  box-shadow: none;
  border: 0 !important;
  background: #fff;
  background-image: none;
  flex: 1;
  padding: 0 0.5em;
  color: #f87e63;
  cursor: pointer;
  font-size: 14px;
  font-family: "Gilroy";
  padding-right: 20px;
  text-align: right;
}
select::-ms-expand {
  display: none;
}
.select {
  position: relative;
  display: flex;
  width: 20em;
  height: 3em;
  line-height: 3;
  background: #fff;
  overflow: hidden;
  border-radius: 0.25em;
}
.select::after {
  content: "\25BC";
  position: absolute;
  top: 0;
  right: 0;
  padding: 0 1em;
  background: #2b2e2e;
  cursor: pointer;
  pointer-events: none;
  transition: 0.25s all ease;
}
.select:hover::after {
  color: #23b499;
}
</style>

<style>
/* Toast notification styles */
.custom-toast {
  --background: #ffffff;
  --color: #1b1b1b;
  --border-radius: 10px;
  --box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  font-family: "Gilroy", sans-serif;
  font-weight: 500;
  font-size: 14px;
}

.custom-toast.toast-danger {
  --background: #ffe0e3;
  --color: #1b1b1b;
}
</style>
